import { useTaskOne } from '@sib/api';
import { DetailsSkeleton } from '@sidecar/common/components/DetailsModal';
import {
  TaskDetailsViewContentRoute,
  TaskDetailsViewContentLocal,
} from './TaskDetailsViewContent';
import type { TaskDetailsNavigationMode } from './TaskDetailsView.types';
import { TASK_DETAILS_SKELETON_FIELD_COUNT } from './TaskDetailsView.utils';

interface TaskDetailsViewProps {
  taskId: string;
  onClose: () => void;
  onEdit: () => void;
  onCreateNextStep?: (parentTaskId: string) => void;
  navigationMode?: TaskDetailsNavigationMode;
}

export const TaskDetailsView = ({
  taskId,
  onClose,
  onEdit,
  onCreateNextStep,
  navigationMode = 'route',
}: TaskDetailsViewProps) => {
  const { data: task, isLoading } = useTaskOne(taskId);

  if (isLoading || !task)
    return <DetailsSkeleton fieldCount={TASK_DETAILS_SKELETON_FIELD_COUNT} />;

  const contentProps = { task, onClose, onEdit, onCreateNextStep };

  if (navigationMode === 'local')
    return <TaskDetailsViewContentLocal {...contentProps} />;

  return <TaskDetailsViewContentRoute {...contentProps} />;
};
